import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { DataProvider } from './data.service';

export interface IError {
  status: string;
  message: string;
  error: Record<string, string[]>;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorProvider {
  /**
   * Converts an Error of Client-Side or Server-Side Type to IError
   * @param error Any Error
   * @returns Converted IError
   */
  convert(error: any) {
    const errorMessage: IError = {} as IError;
    if (error.error && !error.status && !error.url) {
      // Client Error
      errorMessage.message = error.error.message;
    } else {
      // Server Error
      errorMessage.status = error.status;
      errorMessage.message = error.message;
      errorMessage.error = DataProvider.mapCasesReverse(error.error);
    }
    return throwError(() => errorMessage);
  }

  /**
   * Handles an error, logging and show it to the user
   * @param err IError to handle
   */
  handle(err: IError) {
    console.error(err);
    if (Number(err.status) === 0) {
      console.error('Das Backend ist nicht erreichbar! Bitte melden Sie sich bei Ihrem Administrator');
      // TODO: Implement a dialog to show the user that the backend is not reachable
    } else if (Number(err.status) === 401 && err.error && (err.error as any).error === 'No token provided') {
      window.location.reload();
    } else {
      const errStr = 'Error:' + (err.status ? 'with code [' + err.status + ']:' : ':') + err.error[0];
      console.error(errStr);
      // TODO: Implement a toast to show the user the error
    }
  }
}
